<!--
 * @Description: 详情、上传、补充、审核、驳回、红冲、红冲上传。
                 所有进入状态都是通过detailType判断，会有重叠需要根据status再次处理
                 工业为购买方的类型：工业发票，只有查看。不需要工业申请，服务商直接开票
                 服务商为购买方的类型：项目服务费 平台服务费 商务服务费，这三个所有操作都有。委托代开只有申请与查看
                 供应商为购买方的类型：综合服务费，所有操作都有
                 服务商为销售方：工业发票，只有上传操作
                 供应商为销售方：项目服务费 平台服务费 商务服务费
                 管理端为销售方：综合服务费，无补充其他都有。委托代开，单个/批量上传操作与C端上传
                 管理端/C端上传的发票：个体 委托代开，这两种在业务端只能看
                 业务端所有发票都会展示
                 项目服务费 平台服务费 商务服务费 工业发票 都是在业务端内完成的流程

                 详情都有，不可编辑
                 购买方且待审核，可审核(红蓝)，购方驳回
                 销方且待开票，可驳回(红蓝)，销方驳回，与可上传一个状态
                 销方且待开票，可上传(红蓝)，正常票非补充
                 销方且已开票，可补充上传(红蓝)，补充数据根据当前票绑定对应值，detailListBlue||detailListRed。importType会有变化
                 购买方且蓝票已通过，可发起红冲
 * @Date: 2025-06-26 17:34:00
-->
<template>
  <BaseDialog
    width="950px"
    class="form-dialog form-dialog--label120 form-dialog-invoice-custom"
    :title="TITLE[detailType]"
    :model-value="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    :showFooter="false"
  >
    <BaseTextContent>
      <!-- 补充不展示 -->
      <template v-if="!isSupplement">
        <InvoiceDetailDialogInfo
          ref="infoRef"
          :detailType="detailType"
          :invoice-business-type="formData.info.invoiceBusinessType"
          v-model="formData.info"
        />
        <!-- 个体不展示 -->
        <InvoiceDetailDialogAddress
          v-if="!isInvoiceBusinessType7"
          v-model="formData.info"
        />
        <InvoiceDetailDialogDemand v-model="formData.info" />
      </template>

      <!-- 蓝票-->
      <InvoiceDetailDialogFile
        v-if="showBlue"
        ref="blueRef"
        :invoiceFunction="1"
        :detailType="detailType"
        :id="id"
        :invoice-business-type="formData.info.invoiceBusinessType"
        v-model="formData.detailListBlue[0]"
      />
      <!-- 补充不展示 -->
      <!-- 补充材料，仅展示有数据的且不可编辑 -->
      <template v-if="!isSupplement">
        <template v-for="(item, index) in formData.detailListBlue" :key="index">
          <InvoiceDetailDialogFile
            v-if="index"
            :importType="index"
            :invoiceFunction="1"
            :detailType="1"
            :id="id"
            :invoice-business-type="formData.info.invoiceBusinessType"
            v-model="formData.detailListBlue[index]"
          />
        </template>
      </template>

      <!-- 红票仅在有蓝票且是详情、红冲展示 -->
      <InvoiceDetailDialogFile
        v-if="showRed"
        ref="redRef"
        :invoiceFunction="2"
        :detailType="detailType"
        :id="id"
        :invoice-business-type="formData.info.invoiceBusinessType"
        v-model="formData.detailListRed[0]"
      />
      <!-- 补充不展示 -->
      <!-- 补充材料，仅展示有数据的且不可编辑 -->
      <!-- 红票补充永远在蓝票之后，可能蓝票补充1，红票补充2，所以需要加上蓝票补充数量 -->
      <template v-if="!isSupplement">
        <template v-for="(item, index) in formData.detailListRed" :key="index">
          <InvoiceDetailDialogFile
            v-if="index"
            :importType="index + formData.detailListBlue.length - 1"
            :invoiceFunction="2"
            :detailType="1"
            :id="id"
            :invoice-business-type="formData.info.invoiceBusinessType"
            v-model="formData.detailListRed[index]"
          />
        </template>
      </template>

      <!-- 补充不展示 -->
      <InvoiceDetailDialogAudit
        v-if="showAudit"
        ref="auditRef"
        :detailType="detailType"
        :invoiceFunction="invoiceFunctionByStatus(formData.info)"
        v-model="formData._audit"
      />
    </BaseTextContent>
    <template #footer v-if="showBtns">
      <BaseButton type="default" @click="remove">取消</BaseButton>
      <BaseButton v-if="showOpenReject" type="warning" :click="onOpenReject">
        驳回
      </BaseButton>
      <BaseButton :click="onConfirm">提交</BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="tsx" setup>
import { ref, onMounted, computed } from 'vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  XrkMessageBox,
  XrkMessage
} from 'xrk-components';
import {
  invoiceDetail,
  auditInvoice,
  saveInvoice,
  redInvoice,
  openReject
} from '@V/invoice/src/data-source/apis';
import {
  InvoiceDetailData,
  AuditInvoiceParams,
  InvoiceApplyDTO,
  InvoiceApplyDetailListDTO
} from '@V/invoice/src/data-source/types';
import { DetailType } from '@V/invoice/src/types';
import InvoiceDetailDialogInfo from './invoice-detail-dialog-info.vue';
import InvoiceDetailDialogAddress from './invoice-detail-dialog-address.vue';
import InvoiceDetailDialogDemand from './invoice-detail-dialog-demand.vue';
import InvoiceDetailDialogFile from './invoice-detail-dialog-file.vue';
import InvoiceDetailDialogAudit from './invoice-detail-dialog-audit.vue';
import { translator } from '@/utils';

const TITLE = {
  1: '发票详情',
  2: '发票上传',
  3: '发票上传',
  4: '发票补充',
  5: '发票补充',
  6: '发票上传',
  7: '红冲申请',
  10: '发票审核'
};

const props = withDefaults(
  defineProps<{
    id: number;
    detailType?: DetailType; // 根据该字段处理各功能的状态
    remove?: () => {};
  }>(),
  {
    importType: 0,
    detailType: 1
  }
);
const emits = defineEmits<{
  (event: 'success', value: void): void;
}>();

const infoRef = ref(null);
const blueRef = ref(null);
const redRef = ref(null);
const auditRef = ref(null);
const formData = ref<InvoiceDetailData & { _audit: AuditInvoiceParams }>({
  info: {
    id: 0,
    supplierId: 0,
    supplierName: '',
    aspId: 0,
    aspName: '',
    itemName: '',
    itemId: 0,
    invoiceStatus: 0,
    openAt: '',
    invoiceAmount: 0,
    createAt: '',
    invoiceTypeName: '',
    invoiceType: 0,
    invoiceTitle: '',
    invoicePhone: '',
    invoiceIdentifierNo: '',
    invoiceOpenBank: '',
    invoiceBankNo: '',
    invoiceEnterpriseAddress: '',
    isSupplement1: 0,
    isSupplement2: 0,
    receiptFullName: '',
    receiptPhone: '',
    receiptAddress: '',
    authAt: '',
    noPassReason: '',
    invoiceBusinessType: null,
    invoiceOrderNo: '',
    dkPeopleFinishSum: 0,
    dkPeopleTotalSum: 0,
    updateAt: '',
    platformServicesPrice: 0,
    personalScalePrice: 0,
    taskAt: '',
    invoiceMethod: 0,
    taxRate: 0,
    email: '',
    receiptAddressName: '',
    orderMixtureType: null,
    professionType: 0,
    theSeller: 0,
    theSellerName: '',
    demand: '',
    theBuyerName: ''
  },
  detailListBlue: [
    {
      detail: {
        id: null,
        invoiceApplyId: null,
        isMail: null,
        companyCode: '',
        companyName: '',
        trackingNo: '',
        importType: null,
        remark: '',
        createAt: null,
        invoiceType: null
      },
      imgList: [],
      fileList: []
    }
  ],
  detailListRed: [
    {
      detail: {
        id: null,
        invoiceApplyId: null,
        isMail: null,
        companyCode: '',
        companyName: '',
        trackingNo: '',
        importType: null,
        remark: '',
        createAt: null,
        invoiceType: null
      },
      imgList: [],
      fileList: []
    }
  ],
  _audit: {
    invoiceApplyId: null,
    invoiceStatus: null,
    invoiceType: null,
    noPassReason: null
  }
});

// 是否个体
const isInvoiceBusinessType7 = computed(() => {
  return [7, 9, 10].includes(formData.value.info.invoiceBusinessType);
});
// 是否为红票补充
const isSupplementRed = computed(() => {
  return (
    [4, 5].includes(props.detailType) &&
    [6].includes(formData.value.info.invoiceStatus)
  );
});
// 是否为蓝票补充
const isSupplementBlue = computed(() => {
  return (
    [4, 5].includes(props.detailType) &&
    [2].includes(formData.value.info.invoiceStatus)
  );
});
// 是否展示审核内容
const showAudit = computed(() => {
  return (
    // 详情、审核
    [1, 10].includes(props.detailType) &&
    // 待审核与审核完成展示
    [1, 2, 3, 5, 6, 7].includes(formData.value.info.invoiceStatus)
  );
});
// 是否展示红票
const showRed = computed(() => {
  return (
    // 详情、审核并且有红票数据
    ([1, 10].includes(props.detailType) &&
      formData.value.detailListRed[0].detail.id) ||
    // 上传红票
    [3].includes(props.detailType) ||
    isSupplementRed.value
  );
});
// 是否展示蓝票
const showBlue = computed(() => {
  // 默认一直展示，只有补充红票情况下不展示
  return !isSupplementRed.value;
});
// 是否展示操作
const showBtns = computed(() => {
  return props.detailType !== 1;
});
// 是否展示销方驳回
const showOpenReject = computed(() => {
  return (
    showBtns.value &&
    [2, 3].includes(props.detailType) &&
    // 待上传才可销方驳回
    [0, 4].includes(formData.value.info.invoiceStatus)
  );
});
// 是否为补充发票
const isSupplement = computed(() => {
  return [4, 5].includes(props.detailType);
});
/**
 * @description: 根据info整合是蓝还是红
 * @param {InvoiceApplyDTO} info
 * @return {InvoiceFunction} 蓝票1 红票2
 */
const invoiceFunctionByStatus = (info: InvoiceApplyDTO) => {
  return [0, 1, 2, 3].includes(info.invoiceStatus) ? 1 : 2;
};

const onOpenReject = async () => {
  const data = await XrkMessageBox.prompt('请输驳回原因', '提示', {
    cancelButtonText: '取消',
    confirmButtonText: '确认',
    inputType: 'textarea',
    inputErrorMessage: '请输入1-200个字符',
    inputValidator(v) {
      const _v = v.trim();
      return _v.length > 0 && _v.length <= 200;
    }
  });
  await openReject({
    invoiceApplyId: formData.value.info.id,
    invoiceStatus: 0,
    invoiceType: invoiceFunctionByStatus(formData.value.info),
    noPassReason: data.value.trim()
  });
  XrkMessage.success('操作成功');
  emits('success');
  props.remove();
};
const onConfirm = async () => {
  // await Promise.all([blueRef.value.validate(), redRef.value.validate()]);
  const { detailType } = props;
  // 上传蓝红票与补充材料（蓝票）
  if ([2, 3, 4, 5].includes(detailType)) {
    // detailType对应导入类型，正常上传为0，补充1为1，补充2为2
    const DETAIL_IMPORT_MAP = {
      2: 0,
      3: 0,
      4: 1,
      5: 2
    };
    let invoiceSend: InvoiceApplyDetailListDTO = null;
    // 供应商上传蓝票校验 开票信息
    if ([2].includes(detailType)) {
      await infoRef.value.validate();
    }
    // 校验蓝票发票、补充内容
    if ([2].includes(detailType) || isSupplementBlue.value) {
      await blueRef.value.validate();
      invoiceSend = formData.value.detailListBlue[0];
    }
    // 校验红票发票、补充内容
    if ([3].includes(detailType) || isSupplementRed.value) {
      await redRef.value.validate();
      invoiceSend = formData.value.detailListRed[0];
    }
    const {
      imgList,
      fileList,
      detail: { isMail, companyCode, companyName, trackingNo, remark }
    } = invoiceSend;
    const invoiceApplyId = formData.value.info.id;
    const importType = DETAIL_IMPORT_MAP[detailType];
    const invoiceType = invoiceFunctionByStatus(formData.value.info);

    await saveInvoice({
      isMail,
      companyCode,
      companyName,
      trackingNo,
      remark,
      id: invoiceApplyId,
      invoiceApplyId,
      importType,
      invoiceType,
      // 该字段为供应商上传蓝红票时传入
      ...(formData.value.info.taskAt &&
        detailType === 2 && { taskAt: formData.value.info.taskAt }),
      createAt: formData.value.info.createAt
        ? new Date(formData.value.info.createAt).getTime()
        : Date.now(),
      imgList: imgList.map(item => {
        return {
          ...item,
          ...(item.invoiceAmount && {
            // 根据类型提交正/负数
            invoiceAmount: translator.yuan2fen(
              invoiceType === 2 ? -item.invoiceAmount : +item.invoiceAmount
            )
          }),
          invoiceApplyId,
          importType,
          invoiceType
        };
      }),
      fileList: fileList.map(item => {
        return {
          ...item,
          fileName: item.name,
          fileUrl: item.url,
          createAt: item.createAt || Date.now(),
          invoiceApplyId,
          importType,
          invoiceType
        };
      })
    });
  }
  // 发起红票申请
  if (detailType === 7) {
    const data = await XrkMessageBox.prompt('请输入红冲原因', '提示', {
      cancelButtonText: '取消',
      confirmButtonText: '确认',
      inputType: 'textarea',
      inputErrorMessage: '请输入1-200个字符',
      inputValidator(v) {
        const _v = v.trim();
        return _v.length > 0 && _v.length <= 200;
      }
    });
    // 旧流程无红冲金额表单，按文档要求传 0
    await redInvoice({
      invoiceApplyId: props.id,
      reason: data.value.trim(),
      redAmount: 0
    });
  }
  // 审核
  if (detailType === 10) {
    await auditRef.value.validate();
    await auditInvoice(formData.value._audit);
  }
  XrkMessage.success('操作成功');
  emits('success');
  props.remove();
};
onMounted(async () => {
  // 格式化红票、蓝票数组
  const detailListFormat = detailList => {
    detailList?.forEach(item => {
      // invoiceAmount转为元，方便组件内使用，在提交处统一转为分。并且可能为负数，为负数时按正数处理，最终提交时候按类型给负数
      item?.imgList?.forEach(it => {
        it.invoiceAmount = translator.fen2yuan(Math.abs(it.invoiceAmount));
      });
      // 对应上传组件字段
      item?.fileList?.forEach(fl => {
        Object.assign(fl, {
          name: fl.fileName,
          url: fl.fileUrl,
          uid: fl.id
        });
      });
    });
    return detailList;
  };

  const { data } = await invoiceDetail({
    id: props.id,
    // 仅返回补充1数据，该情况对应的detailList只会为一个空数组
    ...([4].includes(props.detailType) && {
      importType: 1
    }),
    // 仅返回补充2数据，该情况对应的detailList只会为一个空数组
    ...([5].includes(props.detailType) && {
      importType: 2
    })
  });
  const { info, detailListRed, detailListBlue } = data as InvoiceDetailData;
  formData.value = {
    ...formData.value,
    info,
    ...(detailListRed.length && {
      detailListRed: detailListFormat(detailListRed)
    }),
    ...(detailListBlue.length && {
      detailListBlue: detailListFormat(detailListBlue)
    }),
    _audit: {
      invoiceApplyId: props.id,
      invoiceStatus: [2, 6].includes(info.invoiceStatus)
        ? 1 // 转换为通过状态
        : [3, 7].includes(info.invoiceStatus)
        ? 0 // 转换为驳回状态
        : null, // 默认状态
      invoiceType: invoiceFunctionByStatus(info),
      noPassReason: props.detailType === 10 ? '' : info.noPassReason // 审核进入后不展示上次驳回原因
    }
  };
});
</script>
<style lang="scss">
.form-dialog-invoice-custom {
  .form-dialog__title {
    font-weight: 600;
    font-size: 16px;
    color: #1d2129;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    > h1 {
      text-align: left;
    }
  }
  .form-dialog__content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0 16px;
  }
  .form-dialog__w280 {
    width: 100%;
  }
}
</style>
